<template>
  <div class="text-switch-container">
    <div
      class="left item"
      :class="{ active: leftActive }"
      @click="toggleView(true)"
    >
      <p>
        <b>{{ leftText }}</b>
      </p>
    </div>
    <div
      class="right item"
      :class="{ active: !leftActive }"
      @click="toggleView(false)"
    >
      <p>
        <b>{{ rightText }}</b>
      </p>
    </div>
    <div class="background-slider" :class="{ right: !leftActive }"></div>
  </div>
</template>

<script>
export default {
  name: 'TextSwitch',
  props: {
    startLeft: {
      type: Boolean,
      default: true,
    },
    leftText: {
      type: String,
      default: 'Left',
    },
    rightText: {
      type: String,
      default: 'Right',
    },
  },
  data() {
    return {
      leftActive: true,
    }
  },
  watch: {},
  computed: {},
  methods: {
    toggleView(leftActive) {
      if (leftActive === this.leftActive) return
      this.leftActive = leftActive
      this.$emit('change', leftActive)
    },
  },
  beforeMount() {
    if (this.startLeft === false) {
      this.leftActive = false
    }
  },
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';
.text-switch-container {
  position: relative;
  display: inline-flex;
  background: $mist;
  border-radius: 16px;
  display: inline-grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  .item {
    padding: 0 12px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    cursor: pointer;
    p {
      font-size: 1rem;
      transition: all 0.15s ease-in-out;
    }
    &.active {
      cursor: default;
      p {
        color: white;
      }
    }
  }
  .background-slider {
    height: 32px;
    position: absolute;
    left: 0;
    top: 0;
    background: $midnight;
    z-index: 0;
    width: 50%;
    border-radius: 16px;
    transition: all 0.15s ease-in-out;
    &.right {
      transform: translateX(100%);
    }
  }
}
@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1200px) {
}
</style>
